const $win = $(window);
const $doc = $(document);

$doc
  .on('change', '.js-update-quantity', event => changeCart(event))
  .on('click', '.js-remove', event => changeCart(event))

function changeCart(event) {
  if (event.type === 'click') {
    event.preventDefault();
  }

  const $this = $(event.target);
  const $product = $this.closest('.js-line-item');
  const id = $product.data('line-id');
  const quantity = event.type === 'change' ? $this.val() : 0;

  if (quantity === 0) {
    $product.fadeOut(function(){
      $product.remove();
    });
  }

  $.ajax({
    type: "post",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id,
      quantity
    },
    success: function (response) {
      updateCart(response)
    }
  });
}

function updateCart (cart) {
  if (cart.items.length === 0) {
    $('.cart .form-cart').empty();

    $.ajax({
      type: 'get',
      url: '/cart',
      success: function (response) {
        $('.cart .form-cart').html($(response).find('.cart .form-cart').html())
      }
    })
  }

  $('.js-cart-count').html(cart.item_count);
  $('.js-cart-total').html(Shopify.formatMoney(cart.original_total_price));

  $.each(cart.items, function(){
    $(`.js-line-item[data-line-id="${this.id}"]`).find('.js-product-total').html(Shopify.formatMoney(this.final_line_price));
  })
}